import TagManager from "react-gtm-module";
const tagManagerEvents = (eventName: any, utm_source: string) => {
  // console.warn("this is event name", eventName, "utm source", utm_source);
  const tagManagerArgs = {
    dataLayer: {
      event: eventName,
      utm_source: utm_source,
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const tagManagerEventsWithoutParameter = (eventName: any) => {
  // console.warn("this is event name", eventName, "utm source", utm_source);
  const tagManagerArgs = {
    dataLayer: {
      event: eventName,
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const AwarenessTagManagerEvents = (dataLayer: any) => {
  const tagManagerArgs = {
    dataLayer: dataLayer,
  };
  TagManager.dataLayer(tagManagerArgs);
};

export default tagManagerEvents;
